import * as React from "react";

interface ReasoningToolPanelDeleteCellProps {
  children: React.ReactNode;
  deleteNode: () => void;
};

export default function ReasoningToolPanelDeleteCell({
  children = [],
  deleteNode,
}: ReasoningToolPanelDeleteCellProps) {
  return (
    <div className="reasoning-tool-panel-delete-cell">
      <div
        className="reasoning-tool-panel-delete-cell-delete-button"
        onClick={deleteNode}
        role="button"
        tabIndex={0}
        aria-label="Delete diagnosis"
        onKeyDown={e => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            // Debug log to verify handler is triggered
            console.log('Delete icon keydown triggered for diagnosis');
            deleteNode();
          }
        }}
      >
        <i className={"icon-trash"} aria-hidden="true"></i>
      </div>
      <div className="reasoning-tool-panel-delete-cell-children">
        {children}
      </div>
    </div>
  );
}
